import { Component, inject, OnInit } from '@angular/core';
import { PageComponent } from '@tytapp/common';
import { HostApi } from '@tytapp/host-api';

@Component({
    selector: 'tyt-membership-benefits',
    templateUrl: './membership-benefits.component.html',
    styleUrls: ['./membership-benefits.component.scss']
})
export class MembershipBenefitsComponent extends PageComponent implements OnInit {
    private hostApi = inject(HostApi);

    benefitsPage: boolean = false;
    get billingEnabled() {
        return this.hostApi.capabilities.includes('web_billing:membership')
            || this.hostApi.capabilities.includes('platform_billing:membership');
    }

    async init() {
        this.pageTitle = `Membership Benefits`;

        if (this.router.url.endsWith('/membership-benefits')) {
            this.benefitsPage = true;
        }
    }

    get joinUrl() {
        return `/join/membership`;
    }

}
